import {
  Flex,
  IconButton,
  IconTrashLine,
  Text,
  ToggleGroup,
  Tooltip,
  View,
} from "@instructure/ui";
import { useTranslation } from "react-i18next";
import React, { useContext, useState } from "react";
import "react-loading-skeleton/dist/skeleton.css";
import { OutcomeCategoryService } from "../../../services/OutcomeCategoryService";
import { Card } from "../../Card";
import { DialogYesNo } from "../../DialogYesNo/DialogYesNo";
import CategoriesModal from "../CategoriesModal/CategoriesModal";
import { UncategorizedContext } from "./CategoryList";
import PLOCard from "./PLOCard";

const PLOCategories = ({
  category,
  setLoadingPlos,
  program,
  handleArchiveOutcome,
  handleUpdateRatingScale,
}) => {
  const { t } = useTranslation();
  const { uncategorizedLos } = useContext(UncategorizedContext);
  const [deleteCategoryOpen, setDeleteCategoryOpen] = useState(false);

  const handleDeleteCategory = async () => {
    await OutcomeCategoryService.deleteOutcomeCategory(category.id).then(() =>
      setLoadingPlos(true)
    );
  };

  return (
    <>
      <ToggleGroup
        defaultExpanded
        toggleLabel={category.name}
        summary={
          <Flex gap="small">
            <Flex.Item shouldGrow shouldShrink>
              <Text>{category.name} </Text>
              <Text fontStyle="italic">{"(" + category.description + ")"}</Text>
            </Flex.Item>
            <Flex.Item>
              <CategoriesModal
                data={
                  category.outcomes
                    ? [...uncategorizedLos].concat([...category.outcomes])
                    : [...uncategorizedLos]
                }
                setLoader={setLoadingPlos}
                title={t("categories.editPloCategory")}
                loType="PSLO"
                service={(category) =>
                  OutcomeCategoryService.updateOutcomeCategory(category)
                }
                selected={{ ...category }}
                program={program}
                type={"edit"}
              />
            </Flex.Item>
            <Flex.Item>
              <Tooltip renderTip={t("global.deleteCategory")}>
                <IconButton
                  screenReaderLabel={t("global.deleteCategory")}
                  renderIcon={IconTrashLine}
                  onClick={() => setDeleteCategoryOpen(true)}
                />
              </Tooltip>
            </Flex.Item>
          </Flex>
        }
      >
        {category?.outcomes?.length === 0 ? (
          <View as="p" padding="small">
            {t("ilo.noOutcomes")}
          </View>
        ) : (
          category?.outcomes.map((outcome, key) => (
            <Card
              key={key}
              style={{
                color: "#0D323F",
                backgroundColor: "#F2F8FA",
                border: "1px solid #ccc",
                borderRadius: 10,
                padding: "5px 15px 15px 15px",
                margin: 15,
              }}
            >
              <PLOCard
                outcome={outcome}
                setLoadingPlos={setLoadingPlos}
                programId={program.id}
                handleArchiveOutcome={handleArchiveOutcome}
                handleUpdateRatingScale={handleUpdateRatingScale}
              />
            </Card>
          ))
        )}
      </ToggleGroup>
      <DialogYesNo
        message={t("ilo.deleteCategoryMessage")}
        openStatus={deleteCategoryOpen}
        onClickNo={() => setDeleteCategoryOpen(false)}
        onClickYes={handleDeleteCategory}
      />
    </>
  );
};

export default PLOCategories;
